import { useMemo, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import AdminSinglePost from './AdminSinglePost'
import Spinner from '../components/Spinner'
import classes from './adminBetKursPoglavlja.module.css'
import { betTypeConfig } from './adminBetKursConfig'

const AdminBetKurs = ({ type = 'betcourse' }) => {
  const [isArray, setIsArray] = useState(false)
  const navigate = useNavigate()
  const axiosPrivate = useAxiosPrivate()
  const [searchInput, setSearchInput] = useState('')
  const { label, queryKey, getPath, createRoute } = betTypeConfig[type]

  const getAllBetKursNovoPosts = async (page = 0) => {
    const { data } = await axiosPrivate.get(`${getPath}?type=${type}`)
    const isArray = await Array.isArray(data.result)
    if (isArray) setIsArray(true)
    return data
  }
  const allBetKursPostsQuery = useQuery({
    queryKey: [queryKey],
    queryFn: getAllBetKursNovoPosts,
    staleTime: 0,
    refetchInterval: 1000 * 60 * 60 * 12,
    keepPreviousData: true,
  })

  const filteredResults = useMemo(() => {
    if (!allBetKursPostsQuery?.data?.result) return []

    return allBetKursPostsQuery.data.result.filter((item) =>
      item.title.toLowerCase().includes(searchInput.toLowerCase())
    )
  }, [allBetKursPostsQuery.data?.result, searchInput])

  if (allBetKursPostsQuery.isError) return <h2>Error...</h2>

  const handleNewChapter = () => {
    navigate(createRoute)
  }

  return (
    <div className={classes.container}>
      {allBetKursPostsQuery.isLoading ? (
        <Spinner />
      ) : (
        <>
          <h1>{label} - POGLAVLJA</h1>
          <div className={classes.top}>
            {isArray && allBetKursPostsQuery.data.result !== undefined && (
              <input
                className={classes.input}
                type='text'
                placeholder='Upiši naslov'
                onChange={(e) => setSearchInput(e.target.value)}
                value={searchInput}
              />
            )}
            {type !== 'calculator' && (
              <button
                onClick={() => handleNewChapter()}
                className={classes.btn}
              >
                Dodaj Novo Poglavlje
              </button>
            )}
          </div>
          <div className={classes.postContainer}>
            <div>
              {isArray
                ? filteredResults.map((post) => {
                    return (
                      <AdminSinglePost
                        post={post}
                        key={post._id}
                        type={queryKey}
                      />
                    )
                  })
                : allBetKursPostsQuery.data.msg}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default AdminBetKurs
